<template>
  <div class="h-96 flex justify-center items-center text-white">
    <div class="contact-card text-center p-6 md:p-12 bg-[#1A2634] rounded-lg shadow-lg max-w-full sm:max-w-md w-full">
      <h1 class="text-3xl sm:text-4xl font-semibold mb-6">{{$t('contacteznous')}}</h1>
      <div class="text-xl sm:text-2xl font-semibold">
        <p>{{ $t('noussommesdisponibleatoutmoment') }} !</p>
        <a href="mailto:letmewaxyou@gmail.com" class="text-[#FF8C42] hover:text-[#e6204b] transition duration-300 mt-4 block">
          letmewaxyou@gmail.com
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
};
</script>

<style scoped>
@import './contact.css';

/* Mise en place d'un fond dégradé, adapté à toutes les tailles d'écran */
.contact-container {
  background: linear-gradient(to right, #3b0a28, #0e171f);
  height: 100vh;
}

.contact-card {
  background-color: rgba(26, 38, 52, 0.8);
  border-radius: 16px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease-in-out;
}

.contact-card:hover {
  transform: scale(1.05);
}

.contact-card a {
  text-decoration: none;
  font-size: 1.25rem;
}

.contact-card a:hover {
  text-decoration: underline;
  color: #e6204b;
}

/* Responsive design */
@media (min-width: 640px) {
  .contact-card {
    padding: 8px 12px;
  }

  .contact-container {
    padding: 0 20px;
  }

  .contact-card h1 {
    font-size: 2.5rem;
  }

  .contact-card p {
    font-size: 1.125rem;
  }
}

@media (min-width: 768px) {
  .contact-card {
    max-width: 600px;
  }
}

@media (min-width: 1024px) {
  .contact-card {
    max-width: 700px;
  }
}
</style>
